import { GameCategory } from '../enums';

export const specialMarketNames = new Set(['Yes', 'Even']);

export const GeneralOddsQueueJobSettings = {
	removeOnComplete: 100,
	removeOnFail: 100,
	stackTraceLimit: 100,
	attempts: 1,
	backoff: {
		type: 'exponential',
		delay: 1000,
	},
};

export const slateGroupScopes: Record<string, string> = {
	[GameCategory.NBA]: 'BY_DAY',
	[GameCategory.NCAAB]: 'BY_DAY',
	[GameCategory.NFL]: 'BY_WEEK',
	[GameCategory.MLB]: 'BY_DAY',
	[GameCategory.EPL]: 'BY_WEEK',
	[GameCategory.UCL]: 'BY_DAY',
	[GameCategory.FIFA]: 'BY_DAY',
	[GameCategory.NHL]: 'BY_DAY',
	[GameCategory.PGA]: 'BY_DAY',
	[GameCategory.ATP]: 'BY_DAY',
	[GameCategory.WTA]: 'BY_DAY',
	[GameCategory.TENNIS]: 'BY_DAY',
	[GameCategory.NCAAF]: 'BY_WEEK',
};

export const sportsbookPriority = ['FanDuel', 'Fanatics'];

export const sportsbookPriorityMap = new Map<string, number>(
	sportsbookPriority.map((s, i) => [s, i])
);

export const regexMarketCreation = new RegExp(`\\b(${['No', 'Odd', 'Under'].join('|')})\\b`, 'i');
